/**
 * Defines the maximum width the page content will extend.
 */
export const MAX_DESKTOP_WIDTH = 1300;

/**
 * Defines the width of the menu bar in desktop mode.
 */
export const DESKTOP_MENU_BAR_WIDTH = 208;

export const DESKTOP_MENU_BAR_HEIGHT = 64;
